<template>
    <form @submit.prevent="submitMerge()">
        <ul>
            <li v-for="order in orders">
                <label>
                    <input type="checkbox" v-model="suborders" :value="order.id">
                    {{ order.id }} - {{ order.buyer_firstname }} {{ order.buyer_lastname }}
                </label>
            </li>
        </ul>

        <p>
            <button type="submit">Spara</button>
        </p>
    </form>
</template>

<script>
export default {
    name: 'MergeOrderList',
    props: ['orders'],
    data: function () {
        return {
            suborders: []
        };
    },
    methods: {
        submitMerge() {
            this.$emit('mergeSubmit', this.suborders);
            this.suborders = [];
        }
    }
}
</script>
